import { DocumentSigningInitiationResponseDtoResponse } from '@asset-metrix/portal-gateway-client-js';
import { MutationFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const initiateSignature: MutationFunction<
  DocumentSigningInitiationResponseDtoResponse,
  { contentId: string; documentId: string }
> = async ({ contentId, documentId }) => {
  const response = await portalGatewayClient.workflow.initiateSignature(
    documentId,
    contentId
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(
        response.error,
        `Error initiating signature for document ${documentId}`
      ),
      response
    );
  }

  return response.data;
};
